// Standard Feature Type core
export function standardFeatureTypeCore() {
  const endpoint = '/standardfeatures/types';
  const detailId = 'standardFeatureTypeId';

  const getDetailId = (data = null) => {
    if (!data) {
      return;
    }

    if (Array.isArray(data)) {
      return data[0][detailId];
    }

    return data[detailId];
  };

  return {
    endpoint,
    detailId,
    getDetailId: getDetailId
  };
}

// Standard Feature Type filter
export function standardFeatureTypeFilter() {
  // Get rows
  const getRows = (data) => {
    const rows = [];

    data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
        value: row.standardFeatureTypeId
      };

      // Object values
      const objects = {
        label: row.standardFeatureTypeDescription
      };

      // Get the text/value from the default culture
      Object.entries(objects).forEach(([j, prop]) => {
        prop.translations.forEach((culture, k) => {
          if (culture.defaultCulture === true) {
            rows[i][j] = culture.text;
          }
        });
      });
    });

    return rows;
  };

  return {
    getRows: getRows
  };
}
